import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BaseFieldComponent } from "../base-field/base-field.component";
import { FieldTypes } from "@nts/std/types";

@Component({
    template: '',
    selector: 'nts-simple-field',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class SimpleFieldComponent extends BaseFieldComponent {
    override type = FieldTypes.Simple;
    abstract get multiline(): boolean;
}
